const $$splitComponentImporter = () => import('/home/runner/work/upple-client-v2/upple-client-v2/src/routes/cm/alignment-calls/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/cm/alignment-calls/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr)
});
export function TSRDummyComponent() {
  return null;
}